import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-338ba278"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-card flex-bwn" }
const _hoisted_2 = {
  key: 0,
  class: "brand-card-info flex-col"
}
const _hoisted_3 = {
  class: "flex-ter-bwn",
  style: {"height":"50px"}
}
const _hoisted_4 = { class: "flex-ter" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex--col" }
const _hoisted_7 = { class: "brand-card-info-name" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"16px","height":"16px","margin-left":"4px"},
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/KoreaIconBorder@3x.png"
}
const _hoisted_9 = {
  key: 1,
  style: {"width":"16px","height":"16px","margin-left":"4px"},
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/ChinaIcon@3x.png"
}
const _hoisted_10 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_11 = { class: "brand-card-info-tag flex-cen-ter ml_10" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "brand-card-info-time",
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand-time.png",
  style: {"position":"relative","z-index":"1","transform":"translateX(20px)"},
  alt: ""
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "brand-card-info-deadline flex-cen-ter"
}
const _hoisted_14 = {
  key: 1,
  class: "brand-card-info-deadline flex-cen-ter"
}
const _hoisted_15 = { class: "flex-ter" }
const _hoisted_16 = ["src", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "flex-cen-ter brand-card-info-btn",
  style: {"opacity":"0.8"}
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "brand-card-attr flex align-baseline" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 3,
  style: {"margin-right":"0 !important"}
}
const _hoisted_25 = { class: "brand-card-biography flex-col rel" }
const _hoisted_26 = { class: "brand-card-biography-title" }
const _hoisted_27 = {
  class: "flex rel",
  style: {"height":"50px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand_instructions.png",
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand_instructions.png",
  alt: ""
}, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "brand-card-images flex-col"
}

import { computed, ref } from 'vue'
import { t } from '@/plugins/i18n'
import LogoIcon from '@/components/common/LogoIcon.vue'
import PreViewImg from './PreViewImg.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { brandDetail, brandAddFavorite, brandRemoveFavorite } from '@/apis/brand'
import { useRoute, useRouter } from 'vue-router'
import { useSite, useRtfix, siteffix, useSite2Station, isMultiStore, isJA, isKO } from '@/store'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { removeTime } from '../components/suffix'
import { confirmLogin } from '@/util/useConfirm'
import { CaretTop, CaretBottom } from '@element-plus/icons-vue'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: ['brandID', 'source', 'data'],
  emits: ['userRequest'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()

const route = useRoute()
const router = useRouter()

// 是否为日本站点
// const isJapanStation = useSite2Station() === 'JapanStation'
const site = useSite()



const isSub = ref(store.getters.isSub)

const brandData = ref<any>({})
const initialIndex = ref(0)
const getBrandDetail = () => {
  const res = { data: props.data }
  brandData.value = res.data
  if (brandData.value.authStartTime) {
    const only = Math.floor((dayjs(brandData.value.authEndTime).unix() - dayjs(brandData.value.authStartTime).unix()) / 3600 / 24)
    if (only > 0 && only < 4) {
      brandData.value.onlyDay = only
    }
  }
  const typeMap = {
    0: t('普通授权'),
    1: t('独家授权'),
    2: t('不可授权')
  }
  brandData.value.customerAuthType = res.data?.customerAuthTypeList?.map(v => {
    return typeMap[v]
  }).join('、')
  brandData.value.previewImgList = res.data?.displayedProductImgList?.map((v, index) => {
    if (v.mainImgFlag) {
      initialIndex.value = index
    }
    return v.url
  })
  brandData.value.mainCategoryFrontListDesc = brandData.value.mainCategoryFrontList?.map(v => {
    console.log(`${siteffix()}Name`)
    return v[`cateName${siteffix()}`]
  }).join('、')
  // brandData.value.brandConcept = brandData.value[`brandConcept${siteffix()}`]
  // brandData.value.brandManual = brandData.value[`brandManual${siteffix()}`]
}

getBrandDetail()

// watch(() => props.brandID, (val) => {
//   val && getBrandDetail(val)
// }, {
//   immediate: true
// })
// 获取平均客单价
const getAveragePrice = () => {
  const { countryCode, currencyAveragePriceMax, currencyAveragePriceMin, averagePriceMin, averagePriceMax } = brandData.value
  // 如果为韩国品牌
  if (countryCode === 'KR') {
    return { averagePriceMin: currencyAveragePriceMin, averagePriceMax: currencyAveragePriceMax }
  }

  return { averagePriceMin, averagePriceMax }
}
const setFavorite = () => confirmLogin(() => {
  const api = brandData.value.favorite ? brandRemoveFavorite : brandAddFavorite
  return api({ brandId: brandData.value.brandId }).then(res => {
    // getBrandDetail(brandData.value.brandId)
    ElMessage.success(brandData.value.favorite ? t('品牌店铺已取消关注') : t('品牌店铺已关注，请前往商品管理-我的收藏中查看'))
    if (brandData.value.favorite) {
      brandData.value.favorite = false
    } else {
      brandData.value.favorite = true
    }
  })
})

const toGetAuth = () => confirmLogin(() => {
  router.push(useRtfix('BrandAuth', { query: { brand: brandData.value.brandId } }))
})

const toBrandDetail = () => confirmLogin(() => {
  router.push(useRtfix('BrandDetail', { params: { brand: brandData.value.brandId } }))
})

const visible = ref(false)
const brandManual = ref('https://theckbs-oss.theckbs.com/customer/header/yjptufn.pdf')
const brandManualTitle = ref(t('品牌说明书'))
const showBrandManual = () => {
  // brandManualTitle.value = t('品牌说明书')
  // brandManual.value = brandData.value.brandManual
  // visible.value = true
  window.open(brandData.value.brandManual)
}
const showAuthManual = () => {
  // brandManualTitle.value = t('品牌授权书')
  // brandManual.value = brandData.value.authUrl
  // visible.value = true
  window.open(brandData.value.authUrl)
}
const cancel = () => {
  brandManual.value = ''
  visible.value = false
}
const fileLinkToStreamDownload = (url, fileName, type) => {
  const xhr = new XMLHttpRequest()
  xhr.open('get', url, true)
  xhr.setRequestHeader('Content-Type', `application/${type}`)
  xhr.responseType = 'blob'
  xhr.onload = function (res) {
    if (this.status === 200) {
      // 接受二进制文件流
      console.log(this)
      var blob = this.response
      const blobUrl = window.URL.createObjectURL(blob)
      // 这里的文件名根据实际情况从响应头或者url里获取
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(blobUrl)
    }
  }
  xhr.send()
}
const ok:any = () => confirmLogin(() => {
  fileLinkToStreamDownload(brandManual.value, brandData.value.brandName, 'pdf')
})

// 三行concept的高度 行高17*3
const conceptEllipsisHeight = 51
const concept = ref()
// 是否折叠
const conceptEllipsis = ref(true)
// 简介那块的高度 用来触发css的动画
const conceptHeight = ref(conceptEllipsisHeight)
// 字有没有太多
const conceptStatus = computed(() => {
  if (concept.value?.scrollHeight > concept.value?.clientHeight) {
    return true
  }
  return false
})
const conceptScrollHeight = computed(() => {
  return concept.value?.scrollHeight
})
const setConceptEllipsis = () => {
  if (conceptEllipsis.value) {
    // 高度和ellipsis分开控制 展开的时候先给高度 不然动画有问题
    conceptHeight.value = conceptScrollHeight.value
    setTimeout(() => {
      conceptEllipsis.value = !conceptEllipsis.value
    }, 200)
    return
  }
  conceptHeight.value = conceptEllipsisHeight
  conceptEllipsis.value = !conceptEllipsis.value
}
const getName = () => {
  if (isJA()) {
    return 'cateNameJp'
  }
  return isKO() ? 'cateNameKr' : 'cateNameEn'
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (brandData.value.brandId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "brand-card-info-logo",
                src: brandData.value.brandLogo,
                alt: ""
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(brandData.value.brandName), 1),
                  (_unref(isJA)() )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (brandData.value.countryCode === 'KR')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                          : (_openBlock(), _createElementBlock("img", _hoisted_9))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (brandData.value.customerAuthStatus === 'SUCCESS')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('已授权__')), 1),
                      _hoisted_12,
                      (!brandData.value.onlyDay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(removeTime)(brandData.value.authStartTime)) + "～" + _toDisplayString(_unref(removeTime)(brandData.value.authEndTime)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('距离授权到期仅剩{day}天',{day:brandData.value.onlyDay})), 1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                class: "brand-card-info-like cursor-pt mr_10",
                src: `https://static-s.theckb.com/BusinessMarket/icon/brand/brand_${brandData.value.favorite ? 'like' : 'unlike'}.png`,
                onClick: _withModifiers(setFavorite, ["stop"])
              }, null, 8, _hoisted_16),
              (brandData.value.customerAuthStatus !== 'SUCCESS')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (brandData.value.customerAuthStatus === 'AUDIT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('申请中')), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (!isSub.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "flex-cen-ter brand-card-info-btn cursor-pt",
                                onClick: _withModifiers(toGetAuth, ["stop"])
                              }, _toDisplayString(_unref(t)('授权申请')), 9, _hoisted_18))
                            : _createCommentVNode("", true)
                        ], 64))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(`${_unref(t)('品牌所在地')}：${brandData.value.country}${brandData.value?.province ?? ''}${brandData.value?.city ?? ''}`), 1),
            (brandData.value.averagePriceMin && brandData.value.averagePriceMax)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(`${_unref(t)('平均客单价')}：${getAveragePrice().averagePriceMin}~${getAveragePrice().averagePriceMax}`), 1),
                  (_unref(isJA)() )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(showCurrentUnit)(brandData.value.countryCode === 'KR')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (brandData.value.mainCategoryFrontList?.length>0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(`${_unref(t)('主营类目')}：${brandData.value.mainCategoryFrontList.map(v => v[getName()])?.join(',')}`), 1))
              : _createCommentVNode("", true),
            (brandData.value.customerAuthType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(`${_unref(t)('授权类型')}：${brandData.value.customerAuthType}`), 1))
              : _createCommentVNode("", true),
            (brandData.value.brandStyleList?.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(t)('品牌风格')) + "：", 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandData.value.brandStyleList, (i, index) => {
              return (_openBlock(), _createElementBlock("span", {
                style: {"margin-right":"10px !important"},
                class: "flex-ter",
                key: index
              }, _toDisplayString(i.name), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('产品理念')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["brand-card-biography-concept rel", {'text-ellipsis': _unref(conceptStatus) && conceptEllipsis.value}]),
              style: _normalizeStyle({ height: `${conceptHeight.value}px` }),
              ref: (_value, _refs) => {
                _refs['concept'] = _value
                concept.value = _value
              }
            }, [
              (_unref(conceptStatus) && conceptEllipsis.value && conceptHeight.value === conceptEllipsisHeight)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "brand-card-biography-concept-ellipsis flex-cen-ter cursor-pt",
                    onClick: setConceptEllipsis
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('展开')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CaretBottom))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(brandData.value.brandConcept) + " ", 1),
              (_unref(conceptStatus) && !conceptEllipsis.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "brand-card-biography-concept-no-ellipsis cursor-pt rel",
                    onClick: setConceptEllipsis
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('收起')) + " ", 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CaretTop))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 6),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("div", {
                class: "brand-card-biography-instructions flex-cen-ter cursor-pt",
                onClick: showBrandManual
              }, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_unref(t)('品牌说明书')), 1)
              ], 512), [
                [_vShow, brandData.value.brandManual]
              ]),
              (brandData.value.customerAuthStatus === 'SUCCESS')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "brand-card-biography-instructions flex-cen-ter cursor-pt",
                    onClick: showAuthManual
                  }, [
                    _hoisted_29,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('下载授权书')), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.source === 'list')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "brand-card-biography-toDetail flex-cen-ter cursor-pt",
                    onClick: toBrandDetail
                  }, _toDisplayString(_unref(t)('进入品牌')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (brandData.value.previewImgList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(PreViewImg, {
            class: "brand-card-images-pre",
            "img-list": brandData.value.previewImgList,
            initialIndex: initialIndex.value,
            "main-height": 270,
            "main-width": 480,
            "pre-height": 90,
            "pre-width": 160
          }, null, 8, ["img-list", "initialIndex"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})